import { render, staticRenderFns } from "./CommissionPay.vue?vue&type=template&id=a9b48966"
import script from "./CommissionPay.vue?vue&type=script&lang=js"
export * from "./CommissionPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports